export const environment = {
  firebase: {
    projectId: 'caprixpress-dev',
    appId: '1:605012060980:web:83e9bd27f08d5a290a9361',
    databaseURL: 'https://caprixpress-dev-default-rtdb.europe-west1.firebasedatabase.app',
    storageBucket: 'caprixpress-dev.firebasestorage.app',
    apiKey: 'AIzaSyBAViTvRZzRoxl_TKh2zwzyhfvkTa8swQ0',
    authDomain: 'caprixpress-dev.firebaseapp.com',
    messagingSenderId: '605012060980',
  },
  production: false,
  rootUrl: 'https://caprixpress.dev.gametailors.com/',
  gameName: 'CapriXpress',
  strapi: {
    strapiApiUrl: 'https://content.caprixpress.dev.gametailors.com/api',
    strapiAuthUrl: '/auth/local',
    strapiRootUrl: 'https://content.caprixpress.dev.gametailors.com',
    readOnlyToken:
      '2ce06f4c3902cba4549a1941eb68060b1878a919ad8163358b331e3200b8ceefedb954f84b64b0bcf8da48fb4d0df127af80471a36980156066fc71db78578372cdb09d84621ce1a2ab434c65aa429871c444ffaefe2770d4c740b42d05525c5f8be16021d53ffecbe18a243a1ff0878ec75143595fd71dbdead9618e40a583d',
  },
};
